import DashboardLoadingGrid from "./dashboardLoader";
import DashboardWidgetsFetchError from "../../../components/dashboardWidgetsFetchError";

interface DashboardWidgetsStatusContainerProps {
  children: React.ReactNode;
  hasData: boolean;
  loadError: boolean;
  loading: boolean;
  refreshDashboard: () => void;
}

const DashboardWidgetsStatusContainer = ({
  children,
  hasData,
  loadError,
  loading,
  refreshDashboard
}: DashboardWidgetsStatusContainerProps) => {
  if (!hasData && loadError) {
    return <DashboardWidgetsFetchError retryRequest={refreshDashboard} />;
  }
  if (loading) {
    return <DashboardLoadingGrid />;
  }
  return <>{children}</>;
};

export { DashboardWidgetsStatusContainer };
